/**
 * UI elements
 */
class ST_UI {
    constructor() {
        this.initFocusForms();
        this.initSmoothScroll();
        this.initPopup();
        this.listServicesToggle();
        this.initTextAccordion();
        this.initDataLayerActions();
    }

    initFocusForms () {
        var inputs = document.querySelectorAll('.has-focus');

        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];

            input.addEventListener('focus', function() {
                this.classList.add('is-active');
                this.parentElement.parentElement.classList.add('is-active');
            });

            input.addEventListener('blur', function() {
                if (this.value === '') {
                    this.classList.remove('is-active');
                    this.parentElement.parentElement.classList.remove('is-active');
                }
            });
        }
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: (target.offset().top - 100)
                    }, 1000);
                }
            }
        });
    }

    initPopup () {
        this.contactPopup = $('.contact-popup');

        document.body.addEventListener('click', e => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#open-contact-popup') {
                e.preventDefault();
                this.contactPopup.removeClass('is-hidden');
                $(document.body).addClass('no-scroll');
                bodyScrollLock.disableBodyScroll(this.contactPopup);
            }
        });

        $('.contact-popup a[href="#close"]').on('click', e => {
            this.contactPopup.addClass('is-hidden');
            $(document.body).removeClass('no-scroll');
            bodyScrollLock.enableBodyScroll(this.contactPopup);
        });
    }

    listServicesToggle () {
        var listWrapper = $('.js-list-to-expand');
        listWrapper.css('height', 0);

        $('.js-toggle-list').on('click', function (e) {
            e.preventDefault();

            var btn = $(this);
            var listContent = listWrapper.find('.list-services');
            listWrapper.toggleClass('is-active');
            var newHeight = listContent.outerHeight(true);

            if (listWrapper.hasClass('is-active')) {
                btn.text(btn.attr('data-text-less'));
                listWrapper.css('height', 0);

                setTimeout(function() {
                    listWrapper.css('height', newHeight + 'px');
                }, 0);

                setTimeout(function() {
                    listWrapper.css('height', 'auto');
                }, 500);
            } else {
                btn.text(btn.attr('data-text-more'));
                listWrapper.css('height', newHeight + 'px');

                setTimeout(function() {
                    listWrapper.css('height', 0);
                }, 0);
            }
        });
    }

    initTextAccordion () {
        let phoneViewport = window.matchMedia("screen and (max-width: 560px)");

        if (phoneViewport.matches) {
            this.moveSectionsWithoutTitleInside();
            this.setupTextAccordion();
        }

        phoneViewport.addListener((mq) => {
            if (mq.matches) {
                this.moveSectionsWithoutTitleInside();
                this.setupTextAccordion();
            } else {
                this.moveSectionsWithoutTitleOutside();
            }
        });
    }

    moveSectionsWithoutTitleInside () {
        let emptyTitles = $('.section-subtitle-empty');
        let allAccordionItems = $('.accordion-item'); 

        emptyTitles.each((i, title) => {
            $(title).parent().attr('data-ui-accordion-hidden-id', i);
        });

        allAccordionItems.each((i, accordion) => {
            $(accordion).attr('data-ui-accordion-order', i);
        });

        allAccordionItems.each((i, accordion) => {
            let siblingAccordions = $(accordion).siblings().filter((i, sibling) => parseInt($(sibling).attr('data-ui-accordion-order'), 10) > parseInt($(accordion).attr('data-ui-accordion-order'), 10));
            let accordionsToMove = [];

            for (let i = 0; i < siblingAccordions.length; i++) {
                if (!siblingAccordions.eq(i).attr('data-ui-accordion-hidden-id')) {
                    break;
                }

                if (siblingAccordions.eq(i).attr('data-ui-accordion-moved')) {
                    continue;
                }

                accordionsToMove.push(siblingAccordions.eq(i));
                siblingAccordions.eq(i).attr('data-ui-accordion-moved', true);
            }

            if (accordionsToMove.length) {
                for (let j = 0; j < accordionsToMove.length; j++) {
                    let content = accordionsToMove[j].find('.accordion-content');
                    content.attr('data-ui-accordion-hidden-content-id', content.parent().attr('data-ui-accordion-hidden-id'));
                    content.appendTo($(accordion).find('.accordion-content > div'));
                    content.css('height', null);
                    content.removeClass('accordion-content');
                }
            }
        });
    }

    moveSectionsWithoutTitleOutside () {
        $('.accordion-item[data-ui-accordion-moved]').removeAttr('data-ui-accordion-moved'); 

        let hiddenContents = $('div[data-ui-accordion-hidden-content-id]');

        for (let i = 0; i < hiddenContents.length; i++) {
            let id = hiddenContents.eq(i).attr('data-ui-accordion-hidden-content-id');
            let parent = $('.accordion-item[data-ui-accordion-hidden-id="' + parseInt(id, 10) + '"]');
            hiddenContents.eq(i).removeAttr('data-ui-accordion-hidden-content-id');
            hiddenContents.eq(i).addClass('accordion-content');
            hiddenContents.eq(i).appendTo(parent);
        }
    }

    setupTextAccordion () {
        if ($(document.body).hasClass('js-ui-accordion-initialized')) {
            return;
        }

        $(document.body).addClass('js-ui-accordion-initialized');

        $(".accordion-item").each(function(i, item) {
            $(item).find('.accordion-content').css('height', 0);

            $(item).on("click", function () {
                let item = $(this);
                let contentWrapper = item.find('.accordion-content');
                let contentText = item.find('.accordion-content > div');

                item.toggleClass('active');
                let newHeight = contentText.outerHeight();

                if (item.hasClass('active')) {
                    contentWrapper.css('height', 0);

                    setTimeout(function() {
                        contentWrapper.css('height', newHeight + 'px');
                    }, 0);

                    setTimeout(function() {
                        contentWrapper.css('height', 'auto');
                    }, 500);
                } else {
                    contentWrapper.css('height', newHeight + 'px');

                    setTimeout(function() {
                        contentWrapper.css('height', 0);
                    }, 0);
                }
            });
        });
    }

    initDataLayerActions () {
        if (!$('.jobs-list-row-cta').length) {
            return;
        }

        let links = $('.jobs-list-row-cta');

        links.each((i, link) => {
            $(link).on('click', e => {
                e.preventDefault();

                dataLayer.push({
                    'event': 'recruitment',
                    'eventCategory': $(link).attr('data-event-category'),
                    'eventAction': $(link).attr('data-event-action')
                }); 

                setTimeout(() => {
                    window.location = $(link).attr('href');
                }, 250);
            });
        });
    }
}